import { Box, Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { ComponentConfig } from "../../Config/ComponentConfig";
import { Colors, STATUS_STYLES } from "../../Constants/Colors";
import { useNavigate } from "react-router-dom";
import { Query } from "../../Types";
import moment from "moment";

interface QueryListCardProps {
  data: Query;
  shouldTap?: boolean;
}

export default function QueryListCard({
  data,
  shouldTap = true,
}: QueryListCardProps) {
  const navigate = useNavigate();
  const feedbackSubmitted = data?.customer_feedback!==null

  const handleCardClick = () => {
    if (!shouldTap) return;
    navigate(`/queries/${data?.id}`);
  };

  const getStatusStyle = (status: string) => {
    switch (status) {
      case "Resolved":
        return STATUS_STYLES.pending.textColor;
      case "Open":
        return STATUS_STYLES.cancelled.textColor;
      case "Closed":
        return STATUS_STYLES.completed.textColor;
      default:
        return STATUS_STYLES.default.textColor;
    }
  };

  const getStatus = () => {
    if (data?.status?.toLowerCase() === "open"){
      return "Open";
    } else if (!feedbackSubmitted) {
      return "Approval Pending";
    } return "Closed"
  }

  return (
    <Card
      onClick={handleCardClick}
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: ComponentConfig.CardBorderRadius,
        boxShadow: 0,
        backgroundColor: Colors.appointmentCardBgColor,
        marginBottom: 1,
        padding: 0,
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          alignItems: "flex-start",
          justifyContent: "center",
          padding: `${ComponentConfig.cardInnerPadding} !important`,
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          gap="4px"
          width="100%"
        >
          <Box
            width="100%"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography>
              <span
                className="small-regular"
                style={{ color: Colors.lightGrey }}
              >
                Issue Type:
              </span>{" "}
              <span
                className="body-regular"
                style={{ color: Colors.primaryTextColor }}
              >
                {data?.issue_type}
              </span>
            </Typography>
            <Typography
              variant="smallRegular"
              className="small-regular"
              style={{ color: Colors.lightGrey }}
            >
              Issue Status
            </Typography>
          </Box>
          <Box
            width="100%"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography>
              <span
                className="small-regular"
                style={{ color: Colors.lightGrey }}
              >
                Issue Date:
              </span>{" "}
              <span
                className="body-regular"
                style={{ color: Colors.primaryTextColor }}
              >
                {moment(data?.created_at).format("DD/MM/YYYY")}
              </span>
            </Typography>
            <Typography
              variant="smallRegular"
              className="body-regular"
              textTransform="uppercase"
              style={{ color: getStatusStyle(data?.status) }}
            >
            {getStatus()}
            </Typography>
          </Box>
          <Typography>
            <span className="small-regular" style={{ color: Colors.lightGrey }}>
              Appointment Id:
            </span>{" "}
            <span
              className="body-regular"
              style={{ color: Colors.primaryTextColor }}
            >
              {data?.appointment_id}
            </span>
          </Typography>

          
        </Box>
      </CardContent>
    </Card>
  );
}
